if (process.env.NODE_ENV === "development") {
  require("preact/debug")
}

// Libraries

import * as $ from "jquery"
import "./utils/initialize_highcharts"

import Turbolinks from "turbolinks"
Turbolinks.start()

// React Components
import StaticAppletComposer from "partners/components/static_applet_composer"
import SuggestedAppletsContainer from "partners/components/suggested_applets"
import ServiceSelect from "partners/components/org_service_select"
import ImageUploader from "partners/components/image_uploader"
import TriggerForm from "partners/components/trigger_form/trigger_form"
import TriggerFieldsForm from "partners/components/trigger_fields_form/trigger_fields_form"
import ActionFieldsForm from "partners/components/action_fields_form/action_fields_form"
import IngredientForm from "partners/components/ingredient_form/ingredient_form"
import IngredientTextField from "shared/components/stored_fields/ingredient_text_field/index"
import PermissionForm from "partners/components/permission_form/permission_form"
import QueryRouter from "partners/components/queries/query_router"
import EndpointTest from "partners/components/endpoint_test/main"
import AdapterScript from "partners/components/adapter_script"
import AuthenticationTest from "partners/components/authentication_test/main"
import Review from "partners/components/review/main"
import PlatformFeedbackCard from "partners/components/platform_feedback/platform_feedback_card"
import PlatformFeedbackPage from "partners/components/platform_feedback/platform_feedback_page"
import SubmitForReview from "partners/components/submit_for_review"
import AppletDefaults from "partners/components/applet_defaults/main"
import EmbeddedRedirectUris from "partners/components/embedded_redirect_uris"
import CloneDelete from "partners/components/service_tools/clone_delete"
import AdminPanel from "partners/components/admin_panel"
import OrganizationContainer from "partners/components/organizations/organization_container"
import ErrorSuccessHistogramChart from "shared/components/error_success_histogram_chart"
import ErrorBreakdownChart from "partners/components/charts/error_breakdown_chart"
import PerformanceCategoryComparisonChart from "partners/components/charts/performance_category_comparison_chart"
import PerformanceTriggerActionChart from "shared/components/performance_trigger_action_chart"
import DynamicApplet from "partners/components/dynamic_applet_composer/main"
import DynamicAppletReview from "partners/components/dynamic_applet_composer/review"
import AppletFeedback from "partners/components/applet_feedback/main"
import PartnerUpdates from "partners/components/partner_updates"
import SolutionAnimation from "partners/components/solutions/solution_animation"
import InformationAnimation from "partners/components/solutions/information_animation"
import UnifiedProfileDropdown from "shared/components/unified_profile_dropdown"
import DeveloperChecklistItem from "app/components/developer_checklist/item.tsx"

// Premium insights
import LineComparisonChart from "partners/components/premium_insights/charts/line_comparison_chart"
import SimpleLineChart from "partners/components/premium_insights/simple_line_chart"
import TopServices from "partners/components/premium_insights/top_services"
import TopCategoriesContainer from "partners/components/premium_insights/top_categories/top_categories_container"
import UsersComponent from "partners/components/premium_insights/users/user_stats"
import EngagementComponent from "partners/components/premium_insights/engagement/engagement_stats"
import BrandComponent from "partners/components/premium_insights/brand_impressions/brand_stats"
import TopPublishedAppletsComponent from "partners/components/premium_insights/top_published_applets/top_published_applets"
import AllTime from "partners/components/premium_insights/all_time"

import CategoriesDetail from "partners/components/premium_insights/detail_pages/categories_detail"
import ServicesDetail from "partners/components/premium_insights/detail_pages/services_detail"
import AppletsDetail from "partners/components/premium_insights/detail_pages/applets_detail"
import UserMetrics from "partners/components/premium_insights/user_metrics/user_metrics"

import ContentfulPostListing from "shared/components/contentful_post_listing/"
import IFTTTNextStory from "app/components/ifttt_next/stories/index"

import ConnectionStartScreen from "partners/components/connection_start_screen/"

// Scripts
import { oneTimeSetup, sharedSetup } from "app/scripts/shared_setup"
import UpdateParam from "app/scripts/update_param"
import Sortable from "sortablejs/modular/sortable.core.esm.js"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import AuthenticationForm from "partners/scripts/authentication_form"
import StepFieldsActions from "partners/scripts/step_fields_actions"
import AdminActions from "partners/scripts/admin_actions"
import ReviewUtils from "partners/scripts/review_utils"
import archiveApplet, { unarchiveApplet } from "partners/scripts/archive_applet"
import displayFlash from "partners/scripts/display_flash"
import disableRestrictedForm from "partners/scripts/disable_restricted_form"
import docsSetup from "partners/scripts/docs_setup"
import ingredientsSortable from "partners/scripts/ingredients_sortable"
import triggerFieldsSortable from "partners/scripts/trigger_fields_sortable"
import actionFieldsSortable from "partners/scripts/action_fields_sortable"
import reviewPipelineActions from "partners/scripts/review_pipeline_actions"
import readonlySelect from "partners/scripts/readonly_actions"
import checklistHashRedirect from "partners/scripts/checklist_redirects"
import formTrimInput from "partners/scripts/form_trim_input"
import dragOrgOwners from "partners/scripts/drag_org_owners"
import pinApplets from "partners/scripts/pin_applets"
import openRemoteLinksInNewWindow from "app/scripts/open_remote_links_in_new_window"
import handleRecaptcha from "shared/handle_recaptcha"
import SwapBGColorsBelowElement from "../app/scripts/swap_bg_colors"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"
import { PlatformAppletList } from "shared/components/applet_list"
import cloneElWidth from "partners/scripts/clone_el_width"
import fetchUserFeedbackInfoSections from "partners/scripts/fetch_user_feedback_info_sections"
import popZendeskWidget from "partners/scripts/open_zendesk_widget_on_links"
import setupHeaderScrollingAnimation from "app/scripts/setup_header_scrolling_animation"

oneTimeSetup()

window.App = Object.assign(window.App, {
  storedFieldPath: resolveUrl => `/stored_fields/options?resolve_url=${resolveUrl}`,
  Comps: {
    DeveloperChecklistItem,
    StaticAppletComposer,
    SuggestedAppletsContainer,
    ServiceSelect,
    ImageUploader,
    TriggerForm,
    TriggerFieldsForm,
    IngredientTextField,
    IngredientForm,
    QueryRouter,
    PermissionForm,
    EndpointTest,
    AdapterScript,
    AuthenticationTest,
    Review,
    PlatformFeedbackCard,
    PlatformFeedbackPage,
    SubmitForReview,
    ActionFieldsForm,
    ErrorSuccessHistogramChart,
    ErrorBreakdownChart,
    PerformanceCategoryComparisonChart,
    PerformanceTriggerActionChart,
    AppletDefaults,
    PartnerUpdates,
    EmbeddedRedirectUris,
    DynamicApplet,
    DynamicAppletReview,
    AppletFeedback,
    ConnectionStartScreen,
    SolutionAnimation,
    InformationAnimation,
    ServiceTools: {
      CloneDelete,
    },
    AdminPanel,
    OrganizationContainer,
    PremiumInsights: {
      TopServices,
      TopCategoriesContainer,
      LineComparisonChart,
      UsersComponent,
      AllTime,
      EngagementComponent,
      BrandComponent,
      SimpleLineChart,
      TopPublishedAppletsComponent,
      UserMetrics,
      Detail: {
        CategoriesDetail,
        ServicesDetail,
        AppletsDetail,
      },
    },
    SmallAppletCard,
    PlatformAppletList,
    ContentfulPostListing,
    IFTTTNextStory,
    UnifiedProfileDropdown,
  },
})

Object.assign(window.App.Scripts, {
  openRemoteLinksInNewWindow,
  handleRecaptcha,
  SwapBGColorsBelowElement,
  SetupUnifiedMobileMenu,
  UpdateParam,
  partners: {
    sharedSetup,
    docsSetup,
    sortable: Sortable,
    AuthenticationForm,
    StepFieldsActions,
    AdminActions,
    ReviewUtils,
    archiveApplet,
    unarchiveApplet,
    displayFlash,
    disableRestrictedForm,
    ingredientsSortable,
    triggerFieldsSortable,
    actionFieldsSortable,
    reviewPipelineActions,
    readonlySelect,
    checklistHashRedirect,
    formTrimInput,
    dragOrgOwners,
    pinApplets,
    cloneElWidth,
    fetchUserFeedbackInfoSections,
    popZendeskWidget,
  },
  setupHeaderScrollingAnimation,
})

export const PlatformApp = window.App

$(document).on("turbolinks:load", () => {
  window.App.Scripts.partners.sharedSetup()
  // Some click listerners wasn't more global. Call directly on Platform until we move to the new way.
  window.uiEventTracker.domPlatformReadySetup()
  window.App.Scripts.partners.disableRestrictedForm()
  window.App.Scripts.partners.formTrimInput()
  window.App.Scripts.partners.dragOrgOwners()
  window.App.Scripts.partners.readonlySelect()
  window.App.Scripts.partners.checklistHashRedirect()
  window.App.Scripts.partners.popZendeskWidget()
  window.scrollTo(0, 0)
})
